import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../environments/environment";
import { Delegation } from "../models/delegation.model";


@Injectable({
    providedIn: 'root'
  })
  export class DelegationService {
    
    constructor(private http: HttpClient){}

    getAllDelegations(): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
        return this.http.get<any>(`${environment.url}/delegation`, { 'headers': headers });
    }

    loadAllDelegation(page: number, size: number, searchValue: string = ''): Observable<any> {
      let headers = new HttpHeaders();
      headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  
      let url = `${environment.url}/delegation?page=${page}&size=${size}`;
      if (searchValue) {
          url += `&searchValue=${encodeURIComponent(searchValue)}`;
      }
  
      return this.http.get<any>(url, { 'headers': headers });
  
    }

    addDelegation(delegate: Delegation): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
        return this.http.post<any>(`${environment.url}/delegation`, delegate, { 'headers': headers });
    }

    deleteUser(idA:number, isUpdatedByBackOffice?: boolean){
      const headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem('kapo_session_id') || '');
        const params = new HttpParams()
                        .set('isUpdatedByBackOffice', String(isUpdatedByBackOffice));
      return this.http.delete(`${environment.url}/delegation/`+idA,{headers, params});
    }

    updateAgregateId(agregate: Delegation): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
        return this.http.put<any>(`${environment.url}/delegation`, agregate, { 'headers': headers });
    }

    updateAgregate(agregate: Delegation, isUpdatedByBackOffice?: boolean): Observable<any> {
        const headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem('kapo_session_id') || '');
        const params = new HttpParams()
                        .set('isUpdatedByBackOffice', String(isUpdatedByBackOffice));
        return this.http.put<any>(`${environment.url}/delegation/`, agregate, { headers, params });
    }

  }